import SmartPhoto from 'smartphoto';
import isMobile from './is-mobile.js';
// $(function(){
//     $(".js-smartPhoto").SmartPhoto();
// });



window.addEventListener('DOMContentLoaded',function(){
    new SmartPhoto(".js-smartPhoto");
});
